<template src="./pagination.html"></template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
  },

  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }
      // When on the last page
      if (this.currentPage === this.totalPages) {
        const page = this.totalPages - this.maxVisibleButtons + 1;
        if (page >= 1) {
          return page;
        }
        return 1;
      }
      // When in between
      return this.currentPage - 1;
    },

    pages() {
      const range = [];

      for (let i = this.startPage;
        i <= Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },

    isInFirstPage() {
      return this.currentPage === 1;
    },

    isInLastPage() {
      return this.currentPage === this.totalPages;
    },

    isPageActive(page) {
      return this.currentPage === page;
    },

    endLength() {
      const end = (this.limit > this.totalItems)
        ? this.totalItems : this.limit * this.currentPage;

      return end > this.totalItems ? this.totalItems : end;
    },

    startLength() {
      return this.limit * (this.currentPage - 1) + 1;
    },
  },

  methods: {
    onClickFirstPage() {
      if (!this.isInFirstPage) {
        this.$emit('pagechanged', 1);
      }
    },

    onClickPreviousPage() {
      if (!this.isInFirstPage) {
        this.$emit('pagechanged', this.currentPage - 1);
      }
    },

    onClickPage(page) {
      this.$emit('pagechanged', page);
    },

    onClickNextPage() {
      if (!this.isInLastPage) {
        this.$emit('pagechanged', this.currentPage + 1);
      }
    },

    onClickLastPage() {
      if (!this.isInLastPage) {
        this.$emit('pagechanged', this.totalPages);
      }
    },
  },
};
</script>

<style>
  .page-item:not(.disabled) {
    cursor: pointer;
  }
  .page-item {
    white-space: nowrap;
  }
</style>
